import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilty , AppMetadataHandler } from 'app/BaseFramework';
import { LookupDataService } from 'app/BaseFramework/core/http/lookupdata.service';
import { WorkqueueService } from 'app/BaseFramework/core/http/workqueue.service';
import * as _ from 'lodash';
import { environment } from 'environments/environment';
// import * as workflowJson from './stage-timeline-data.json';

import * as moment from 'moment/moment';
@Component({
  selector: 'app-stage-timeline',
  templateUrl: './stage-timeline.component.html',
  styleUrls: ['./stage-timeline.component.scss'],
  providers: []
})
export class StageTimelineComponent implements OnInit {

  constructor(private lookupDataService: LookupDataService,
    private commonUtility: CommonUtilty,
    private appMetadataHandler: AppMetadataHandler,
    private workQueueService: WorkqueueService) { }

  @Input() workQueueItem;
  journey : string = 'NBU Journey'
  ngOnInit(): void {
    this.getStageList();
    let currentStageData = this.workQueueItem ? this.stageList.filter(item => item.lookupKey == this.workQueueItem.stageCd) : [];
    this.currentStage = currentStageData ? currentStageData[0] ? currentStageData[0].sortOrder ? currentStageData[0].sortOrder : 0 : 0 : 0; 
    this.getAuditData();
  }

  stageList = [];
  currentStage = null;
  getStageList() {
    if(!this.commonUtility.isArrayIterable(this.appMetadataHandler['stageList'])){
    this.lookupDataService.getLookup('policyStageCd').subscribe(resp => {
      
      if (resp && this.commonUtility.isArrayIterable(resp)) {
        this.stageList = _.sortBy(resp, 'sortOrder');
        this.stageList = this.stageList.filter(item => item.lookupKey != 'CLAIM_REJECT');
        let currentStageData = this.workQueueItem ? this.stageList.filter(item => item.lookupKey == this.workQueueItem.stageCd) : [];
        this.currentStage = currentStageData ? currentStageData[0] ? currentStageData[0].sortOrder ? currentStageData[0].sortOrder : 0 : 0 : 0; 
        this.appMetadataHandler['stageList'] = [...this.stageList];
        let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
        if (activeIndx > -1) {
          this.activateItem(activeIndx);
        } else {
          this.activateItem(0);
        }
      }else{
        resp = this.demoStageList;
        this.stageList = _.sortBy(resp, 'sortOrder');
        this.stageList = this.stageList.filter(item => item.lookupKey != 'CLAIMREJECT');
        this.appMetadataHandler['stageList'] = [...this.stageList];
        let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
        if (activeIndx > -1) {
          this.activateItem(activeIndx);
        } else {
          this.activateItem(0);
        }
      }

    })
  }else{
    this.stageList = [...this.appMetadataHandler['stageList']];
    let activeIndx = this.workQueueItem ? this.stageList.findIndex(item => item.lookupKey == this.workQueueItem.stageCd) : -1;
    if (activeIndx > -1) {
      this.activateItem(activeIndx);
    } else {
      this.activateItem(0);
    }
  }
  }

  activateItem(itemIndex: number) {
    for (let i = 0; i < this.stageList.length; i++) {
      if (i < itemIndex) {
        this.stageList[i].status = 'completed';
      } else if (i === itemIndex) {
        this.stageList[i].status = 'active';
      } else {
        this.stageList[i].status = 'pending';
      }
    }
  }

  workFlowAudit: any = [];
  getWorkflowAuditSubject$ = null;
  getAuditData() {

    if (this.getWorkflowAuditSubject$) this.getWorkflowAuditSubject$.unsubscribe();
    if (this.workQueueItem) {
      this.getWorkflowAuditSubject$ = this.workQueueService.getWorkflowAudit(this.workQueueItem['entityGuid'], "").subscribe(resp => {
        this.workFlowAudit = resp;
        this.setWorkFlowDataForStageTimeline();
      });
    }
  }

  counter = 0;
  setWorkFlowDataForStageTimeline() {
    if (this.commonUtility.isArrayIterable(this.workFlowAudit) && this.commonUtility.isArrayIterable(this.stageList)) {
      this.workFlowAudit.forEach(workflowItem => {
        let stageIndx = this.stageList.findIndex(stageData => stageData.lookupAddValue1 == workflowItem['serviceTask']);
        if (stageIndx > -1) {
          this.stageList[stageIndx]['workflowData'] = workflowItem;
        }
        let stageTaskIndx = this.stageList.findIndex(stageData => stageData.lookupKey == workflowItem['stageCd']);
        if (stageTaskIndx > -1) {
          this.stageList[stageIndx]['workflowData'] = workflowItem;
        }
      });
    } else {
      if (this.counter < 3) {
        setTimeout(() => {
          this.counter += 1;
          this.setWorkFlowDataForStageTimeline();
        }, 500);
      }
    }
  }

  expandStageTimelineCard(index) {
    if (this.commonUtility.isArrayIterable(this.stageList) && this.stageList[index]['workflowData']) {
      this.stageList[index].isExpanded = !this.stageList[index].isExpanded;
    }
  }
  closeStageTimelineCard(index: number) {
    this.stageList[index].isExpanded = false;
  }
  getDayDifference(startDt, endDt) {

    var start = moment(startDt, ['X', 'x', 'DD-MM-YYYY']);
    var end = moment(endDt, ['X', 'x', 'DD-MM-YYYY']);
    // return end.from(start, true);

    var time = endDt - startDt;
    var seconds = moment.duration(time).seconds();
    var minutes = moment.duration(time).minutes();
    var hours = moment.duration(time).hours();
    var days = moment.duration(time).days();

    if (days == 0 && hours == 0)
      return minutes + " minutes " + seconds + " seconds";
    else
      return days + " days " + hours + " hours " + minutes + " minutes " + seconds + " seconds";
  }

  getHourDifference(startDt, endDt) {
    var start = moment(startDt, ['X']);
    var end = moment(endDt, ['X']);
    return end.from(start, true);

  }
  demoStageList = [
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "PENDINGDE",
        "lookupValue": "Data Entry",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 1,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingautoadj",
        "lookupValue": "Auto Underwriting",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 2,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingmadj",
        "lookupValue": "Manual Underwriting",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 3,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "CLAIM_REJECT",
        "lookupValue": "Claim Rejected\t",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 99,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "pendingpayoutclearance",
        "lookupValue": "Payment",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 4,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    },
    {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": 1692602988520,
        "createdUser": null,
        "updatedUser": null,
        "baseCompanyCd": null,
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "exceptionDOList": null,
        "businessKey": null,
        "statusCd": null,
        "applicableCountryCd": null,
        "applicableComponentCd": null,
        "txStatusCd": null,
        "txStageCd": null,
        "txDecisionCd": null,
        "submissionModeCd": null,
        "stageCd": null,
        "checkersDecision": null,
        "checkersRemarks": null,
        "checkersDicisionDt": null,
        "id": null,
        "lookupCd": "ClaimStateCd",
        "lookupKey": "claimfinal",
        "lookupValue": "Generate Policy",
        "lookupAddValue1": "null",
        "defaultFl": null,
        "sortOrder": 7,
        "parentLookupCd": null,
        "displayFl": null,
        "criteriaLookupKey": null,
        "lookupValueKey": null,
        "lookupAddValue2": "null",
        "objectName": "LookupDataDO",
        "code": null,
        "referenceNum": null,
        "baseAdditionalFields": null
    }
];

}
